module.exports = "<div\n  *ngIf=\"message && panel == true\"\n  [ngClass]=\"{\n    alert: message,\n    'alert-success': message.type === 'success',\n    'alert-danger': message.type === 'error',\n    'alert-warning': message.type === 'warning',\n     'alert-info': message.type === 'info'\n  }\"\n>\n  {{ message.text }}\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/alert/alert.component.html
// module id = ./src/app/_directives/alert/alert.component.html
// module chunks = main